export default function search(value, containerEl, timeout) {
  if (timeout) {  
    clearTimeout(timeout);
  }

  const isMobileOrTablet = window.matchMedia("(max-width: 1189px)").matches;
  const mobileMenuEl = document.getElementById("js-mobile-menu");

  timeout = setTimeout(async function() {
    document.documentElement.scrollTo(0, 0, { behavior: "smooth" });
    document.body.classList.add("overflow-hidden");

    containerEl.classList.remove("d-none");
    containerEl.querySelector(".dh-search__results-inner").classList.add('d-none')
    containerEl.querySelector(".dh-search__results-empty").classList.add("d-none");
    containerEl.querySelector(".dh-search__results-link").classList.add("d-none");
    containerEl.querySelector('.dh-search__results-loader').classList.remove("d-none");

    try {
      const response = await fetch(`/search?query=${value}`);
      const data = await response.json();

      if (isMobileOrTablet && mobileMenuEl) {
        mobileMenuEl.classList.add("d-none");
        mobileMenuEl.classList.remove("show");
        mobileMenuEl.classList.remove("d-none");
      }

      containerEl.querySelector('.dh-search__results-loader').classList.add("d-none");
      containerEl.querySelector(".dh-search__results-title").innerHTML = `${containerEl.dataset.title}<br/>«${value}»`;

      let html = '';
      if (data && data.length) {
        data.forEach((category) => {
          html += `
          <div class="dh-search__results-item dh-search-result">
            <a href="${category.url}" class="dh-search-result__title">
              ${category.category_name} (<span class="text-secondary">${category.total}</span>)
            </a>
          `;
          if (category.results && category.results.length) {
            html += `<div class="dh-search-result__list">`;
            category.results.forEach((product) => {
              html += `
                <a href="${product.url}" class="dh-search-result__item">
                  ${product.label}
                </a>
              `;
            });
            html += `</div>`;
          }
          html += `</div>`;
        });
      }

      if (html) {
        containerEl.querySelector(".dh-search__results-inner").classList.remove('d-none')
        containerEl.querySelector(".dh-search__results-inner").innerHTML = html;
        containerEl.querySelector(".dh-search__results-link").classList.remove("d-none");
      } else {
        containerEl.querySelector(".dh-search__results-inner").classList.add('d-none')
        containerEl.querySelector(".dh-search__results-empty").classList.remove("d-none");
        containerEl.querySelector(".dh-search__results-link").classList.add("d-none");
      }
    } catch (e) {
      console.error(error);
    }
  }, 500);
}
